export const makeInputSize = size => Math.round(SIZE_MAP[size] * (20 / 24));
export const makeMarginSize = size => (SIZE_MAP[size] - makeInputSize(size)) / 2;

export type SIZES = 'small' | 'regular' | 'large';

export const SIZE_MAP = {
    ['small']: 20,
    ['regular']: 20,
    ['large']: 24,
};
